module.exports = __webpack_public_path__ + "static/media/walking.7b139594.jpg";